<template>
  <div class="step-container">
    <div class="step-info d-flex align-items-center justify-content-between">
      <div>
        <div class="count-step">
          Schritt {{ currentStepIndex }} von {{ totalSteps }}
        </div>
        <div class="name-step">
          {{ currentStep.name }}
        </div>
        <div class="description-step" v-html="currentStep.description" />
      </div>
    </div>
    <options />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Options from './options'
export default {
  components: {
    Options
  },
  computed: {
    ...mapGetters({
      currentStep: 'configurator/currentStep',
      steps: 'configurator/navigation'
    }),
    totalSteps () {
      return this.steps.length
    },
    currentStepIndex () {
      return this.steps.findIndex(s => s.id === this.currentStep.id) + 1
    }
  }
}
</script>
